/**
 * Which Dimensions implementation to render.
 *
 * Driven solely by the LaunchDarkly `dimensionsRevamp` flag.
 * Default is the revamp when the flag is undefined (e.g. local dev / flag
 * not yet created) — create the flag in LD before shipping if the original
 * should stay live there.
 */
export const isDimensionsRevampEnabled = (flags?: { dimensionsRevamp?: boolean }): boolean =>
  flags?.dimensionsRevamp ?? true;

export default isDimensionsRevampEnabled;
